<template>
  <!-- modal-add-to-planning -->
  <div class="modal-atp">
    <h2 class="lvl2-heading">
      Votre demande personnalisée : message, nom du produit, code EAN, prix etc.
    </h2>
    <request-table
      :is-content="modal.payload.request"
      class="supports__form--editor"
      ref="request-table"
    />
    <div>
      <div class="supports__form--actions">
        <span>Ajoutez un/des fichier(s) :</span>
        <button class="supports__form--button" @click.prevent="addPlanLine">
          +
        </button>
      </div>
      <div class="supports__form--plans">
        <div
          class="supports__form--plan"
          v-for="(file, key) in files"
          :key="`files__${file.id}`"
        >
          <!-- <ImageThumbnail
                  @click.native="openBlueprintModal"
                  v-if="
                    params.pharmacy_files &&
                      typeof params.pharmacy_files === 'string'
                  "
                  :imageUrl="params.pharmacy_files"
                /> -->
          <FileUpload
            name="thumbnail-upload"
            :key="`files__upload--${file.id}`"
            :placeholder="
              typeof file.file == 'string'
                ? file.file.name
                : file.file
                ? file.file.name
                : 'Fichier'
            "
            :acceptedTypes="[
              'application/pdf',
              'image/png',
              'image/gif',
              'image/bmp',
              'image/jpeg',
              'image/jpg',
              'image/svg+xml',
              'image/x-icon',
              'image/pipeg',
              'video/mp4',
              'video/mpeg',
              'video/quicktime',
              'video/x-la-asf',
              'video/x-ms-asf',
              'video/x-msvideo',
              'video/x-sgi-movie'
            ]"
            :upload="!file.file"
            @file-upload="fileUpload($event, `files__${file.id}`)"
          />
          <button
            class="supports__form--button"
            @click.prevent="removePlanLine(key, $event)"
          >
            -
          </button>
        </div>
      </div>
    </div>
    <div class="modal__actions">
      <base-button class="modal__actions--button" @click.native="confirmRequest"
        >Valider</base-button
      >
      <base-button
        class="modal__actions--button"
        @click.native="closeModal"
        type="hollowed"
        >Annuler</base-button
      >
    </div>
  </div>
</template>

<script>
// import ModalAddToplanningMonth from "./ModalAddToplanningMonth"
// import { fetchPlannings } from "@/api/plannings"
import RequestTable from "@/views/VideoCatalog/components/RequestTable"
import { planningMixin } from "@/mixins"
import { mapGetters } from "vuex"
import FileUpload from "@/components/FileUpload.vue"
export default {
  data() {
    return {
      plannings: null,
      searchword: "",
      initSelected: ["Tous"],
      baseTree: [
        {
          title: "Tous",
          expanded: true,
          checked: false,
          children: []
        }
      ],
      videosAddedSuccessfully: false,
      selectedSupports: [],
      supportTypes: [],
      files: []
    }
  },
  mixins: [planningMixin],
  components: {
    // ModalAddToplanningMonth
    FileUpload,
    RequestTable
  },
  computed: {
    ...mapGetters(["currentVideo", "modal"])
  },
  methods: {
    addPlanLine() {
      this.files.push({
        id: this.files.length + 1,
        file: null
      })
    },
    removePlanLine(index) {
      let plansBackup = [...this.files]
      setTimeout(() => {
        this.files = null
        plansBackup = plansBackup.filter((row, i) => {
          return i !== index
        })
        this.files = plansBackup
      }, 20)
    },
    confirmRequest() {
      const { content } = this.$refs["request-table"]
      this.$root.$emit("confirm", {
        files: this.files.filter(file => !!file.file),
        request: content
      })
      this.closeModal()
    },
    fileUpload(file, index) {
      this.files = this.files.map((row, i) => {
        if (index === `files__${i + 1}`) {
          row.file = file
        }
        return row
      })
    },
    sendContent() {
      const { content } = this.$refs["request-table"]
      this.$root.$emit("confirm", {
        request: content,
        files: this.files
      })
    },
    closeModal() {
      this.$store.dispatch("closeModal")
    }
  },
  mounted() {
    this.sendContent()
    this.files = this.modal.payload.files
      ? this.modal.payload.files.map((file, id) => ({
          id,
          file
        }))
      : []
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.tox-notifications-container,
.tox-statusbar {
  display: none !important;
}
.modal {
  &__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-top: 20px;
  }
}
.modal-atp {
  $self: &;
  width: $modal-add-to-planning-width;
  /* 
  &__month {
    font-family: $font-family-muli;
    font-weight: 800;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 15px;
    .lvl3-heading {
      margin-bottom: 7px;
    }
    #{$self}__button-wrapper {
      width: 208px;
      align-self: center;
    }
  }

  &__month-wrapper {
    display: inline-block;
  }

  &__content {
    &--free {
      margin-bottom: 13px;
      & > span {
        color: $color-secondary;
        color: var(--color-secondary, $color-secondary);
      }
      #{$self}__slots {
        .occupied {
          background: $color-secondary;
          background: var(--color-secondary, $color-secondary);
        }
      }
    }
    &--premium {
      & > span {
        color: $color-accent;
        color: var(--color-accent, $color-accent);
      }
      #{$self}__slots {
        .occupied {
          background: $color-accent;
          background: var(--color-accent, $color-accent);
        }
      }
    }
  }

  &__slots {
    span {
      display: inline-block;
      height: 10px;
      width: 100px;
      margin-right: 2px;
      background: $color-neutral-3;
      background: var(--color-neutral-3, $color-neutral-3);
    }
  }

  &__alert {
    font-family: $font-family-worksans;
    margin-top: 8px;
    font-size: 0.8em;
    text-align: center;
    display: block;
    color: $color-semantic--error;
    color: var(--color-semantic--error, $color-semantic--error);
  }
*/
}
.supports__form {
  &--container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
  &--plan {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // max-height: 50px !important;
    .supports__form--button {
      min-width: 48px !important;
      margin-left: 10px;
    }
    .file-upload {
      min-width: unset !important;
      width: 100%;
      max-width: 600px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      &__alert {
        word-break: break-word;
      }
      &__inner-wrapper {
        height: 50px;
      }
      .file-upload__file-name {
        max-width: 360px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div.link {
        line-height: unset !important;
        a {
          height: 30px;
        }
      }
      .file-upload__inner-wrapper {
        width: 100%;
      }
    }
  }
  &--actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
  &-item {
    display: grid;
    grid-template-columns: 1fr 1fr 0.5fr 0.2fr;
    grid-gap: 10px;
    // justify-items: center;
    justify-items: flex-end;
  }
  &--button {
    // background-color: #000;
    cursor: pointer;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fbac2e;
    border: 2px solid var(--color-secondary, #fbac2e);
    outline: none;
    color: white;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    font-size: 25px;
    text-transform: uppercase;
    background: var(--color-secondary, #fbac2e);
    &:hover {
      box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.16);
    }
    &.marged {
      margin: 0 14px 20px auto;
    }
  }
}
</style>
